import { render, staticRenderFns } from "./system-export-sheet.vue?vue&type=template&id=5023993a&scoped=true"
import script from "./system-export-sheet.vue?vue&type=script&lang=js"
export * from "./system-export-sheet.vue?vue&type=script&lang=js"
import style0 from "./system-export-sheet.vue?vue&type=style&index=0&id=5023993a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5023993a",
  null
  
)

export default component.exports